export const CURRENT_USER = JSON.parse(sessionStorage.getItem("current_user"))
export const CURRENT_FLEET = JSON.parse(sessionStorage.getItem("current_fleet"))
export const LANGUAGE = CURRENT_USER && CURRENT_USER.language
export const ISFMC = CURRENT_USER && CURRENT_USER.isFMC
